<template>
  <div class="entry-toolbar">
    <!--
      This is here to balance the visible input to the right of the save
      button, so the save button stays centered.
    -->
    <InputNumber
      v-if="allowBatch"
      :model-value="0"
      show-buttons
      aria-hidden="true"
      class="w-2 opacity-0"
    />
    <RygenButton
      mode="primary"
      icon="pi pi-save"
      :disabled="disabled"
      :label="saveButtonLabel"
      :loading="loading"
      juicy
      @click="emit('save')"
    />
    <InputWrapper
      v-if="allowBatch"
      v-slot="{ ariaProps, inputId }"
      input-id="entry-toolbar-batch-amount"
      :label="t('common.copies', 2)"
      class="w-2"
    >
      <InputNumber
        v-model="batchAmount"
        v-bind="ariaProps"
        :input-id="inputId"
        :min="1"
        :max="20"
        show-buttons
        :placeholder="t('common.copies', 2)"
      />
    </InputWrapper>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import RygenButton from '@rygen/rygen-ui/components/button/RygenButton.vue';
import InputWrapper from '@rygen/rygen-ui/components/form/InputWrapper.vue';
import InputNumber from 'primevue/inputnumber';

const batchAmount = defineModel('batchAmount', {
  type: Number,
  default: () => 1,
});

const props = defineProps({
  saveButtonLabel: {
    type: String,
    required: true,
  },
  loading: {
    type: Boolean,
    default: () => false,
  },
  disabled: {
    type: Boolean,
    default: () => false,
  },
  allowBatch: {
    type: Boolean,
    default: () => false,
  },
});
const { loading, disabled, allowBatch } = toRefs(props);
const emit = defineEmits<{
  (event: 'save'): void;
}>();

const { t } = useI18n();
</script>

<style>
.entry-toolbar {
  display: flex;
  gap: var(--gap-1);
  justify-content: center;
  align-items: end;
  padding: var(--sp-3);

  .p-inputnumber {
    pointer-events: all;
  }
}
</style>
